import * as React from "react";
import "./global.css";

import { ApolloProvider } from "react-apollo";
import client from "./src/context/ApolloContext";

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
);
